<template>
  <div class="landing-page">
    <el-card shadow="never">
      <template #header>
        <div class="card-header">
          <span>🌉 我的数字名片</span>
          <span class="sub">填一次资料，AI 自动生成账号包装 + 私信中间页，打通抖音↔私域</span>
        </div>
      </template>

      <!-- 步骤条 -->
      <el-steps :active="step" align-center style="margin-bottom: 24px">
        <el-step title="填资料" description="产品/卖点/微信" />
        <el-step title="AI 生成" description="5件套 + 中间页" />
        <el-step title="发布使用" description="复制链接发私信" />
      </el-steps>

      <!-- Step 1: 填表 -->
      <div v-if="step === 0">
        <div class="row">
          <span class="label">选择账号：</span>
          <el-select v-model="form.account_id" placeholder="选择要配置的账号" class="lp-wide" @change="loadPage">
            <el-option v-for="acc in accounts" :key="acc.id" :label="`${acc.nickname}（${acc.username}）`" :value="acc.id" />
          </el-select>
          <el-tag v-if="form.industry" type="success" style="margin-left: 12px">{{ form.industry }}</el-tag>
        </div>
        <el-divider />
        <el-form :model="form" label-width="100px" size="default">
          <el-form-item label="产品/服务名">
            <el-input v-model="form.product_name" placeholder="如：轻奢珠宝定制 或 XX口腔诊所" />
          </el-form-item>
          <el-form-item label="产品描述">
            <el-input v-model="form.product_desc" type="textarea" :rows="3" placeholder="一句话介绍你的产品/服务，突出优势" />
          </el-form-item>
          <el-form-item label="卖点/信任点">
            <el-input v-model="form.selling_points" placeholder="逗号分隔，如：源头厂家,支持定制,全国包邮,3年质保" />
            <div class="hint">这些卖点会显示在中间页的绿色信任条里</div>
          </el-form-item>
          <el-form-item label="微信">
            <el-input v-model="form.contact_wechat" class="lp-wide" placeholder="用于客户添加" />
          </el-form-item>
          <el-form-item label="手机号">
            <el-input v-model="form.contact_phone" class="lp-wide" placeholder="选填" />
          </el-form-item>
          <el-divider content-position="left">✨ V2 转化设置（提升客户转化率）</el-divider>
          <el-form-item label="老板昵称">
            <el-input v-model="form.boss_name" class="lp-wide" placeholder="如：老张（用于「老板有话说」）" />
          </el-form-item>
          <el-form-item label="从业年限">
            <el-input v-model="form.boss_years" class="lp-wide" placeholder="如：8年（增强可信度）" />
          </el-form-item>
          <el-form-item label="福利钩子">
            <el-input v-model="form.welfare" placeholder="如：私信暗号【找客户】→ 免费领选购参考/免费出方案" />
            <div class="hint">给客户一个行动理由（真实资料/咨询，不承诺收益）</div>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :loading="saving" @click="saveForm">💾 保存资料</el-button>
            <el-button type="success" :loading="generating" :disabled="!form.product_name" @click="generateAll">🤖 AI 一键生成</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- Step 2: 预览结果 -->
      <div v-if="step === 1">
        <el-tabs v-model="previewTab">
          <!-- 5 件套 -->
          <el-tab-pane label="📱 账号包装 5 件套" name="package">
            <div v-if="content.avatar_prompt" class="package-grid">
              <div class="pkg-item">
                <div class="pkg-label">🖼 头像</div>
                <div class="pkg-value">{{ content.avatar_prompt }}</div>
              </div>
              <div class="pkg-item">
                <div class="pkg-label">✏️ 昵称</div>
                <div class="pkg-value">
                  <el-tag v-for="(n, i) in content.nickname_options" :key="i" style="margin: 2px">{{ n }}</el-tag>
                </div>
              </div>
              <div class="pkg-item">
                <div class="pkg-label">📝 简介</div>
                <div class="pkg-value">{{ content.bio }}</div>
              </div>
              <div class="pkg-item">
                <div class="pkg-label">🌄 背景图</div>
                <div class="pkg-value">{{ content.bg_prompt }}</div>
              </div>
              <div class="pkg-item" v-for="(v, i) in content.pinned_videos" :key="'v'+i">
                <div class="pkg-label">📹 置顶{{ i+1 }}：{{ v.title }}</div>
                <div class="pkg-value script">{{ v.script }}</div>
              </div>
            </div>
            <el-empty v-else description="尚未生成，请先保存资料后点击 AI 生成" />
          </el-tab-pane>

          <!-- 中间页预览 -->
          <el-tab-pane label="🌐 中间页预览" name="landing">
            <div v-if="pageUrl" class="preview-bar">
              <span>专属链接：</span>
              <el-tag type="success" size="large">{{ pageUrl }}</el-tag>
              <el-button size="small" type="primary" @click="copyUrl">📋 复制链接</el-button>
              <el-button size="small" @click="openPreview">👁 预览</el-button>
            </div>
            <el-empty v-else description="尚未生成中间页" />
            <div class="dm-tip">
              💡 <b>私信话术建议：</b>第一段发问候+价值（如"你好，看到你在找XX，我们是源头厂家，这是我们的产品介绍👇"），第二段发链接 <code>{{ pageUrl }}</code>
            </div>
          </el-tab-pane>
        </el-tabs>
        <div style="margin-top: 16px; text-align: center">
          <el-button @click="step = 0">← 返回修改</el-button>
          <el-button type="primary" @click="step = 2">下一步 →</el-button>
        </div>
      </div>

      <!-- Step 3: 发布使用 -->
      <div v-if="step === 2" class="done-section">
        <el-result icon="success" title="桥梁已架好！" sub-title="商户账号有了信任内容，中间页可以承接私域客户">
          <template #extra>
            <el-button type="primary" @click="copyUrl">📋 复制中间页链接</el-button>
            <el-button @click="step = 0">返回修改</el-button>
          </template>
        </el-result>
        <div class="done-cards">
          <el-card shadow="hover">
            <template #header>📱 抖音端</template>
            <p>按 5 件套方案修改头像/昵称/简介/背景图</p>
            <p>拍摄 3 个置顶视频（案例/产品/公司）</p>
            <p>→ 被捞的客户看到有内容的账号，信任度翻倍</p>
          </el-card>
          <el-card shadow="hover">
            <template #header>💬 私信端</template>
            <p>互关之后，第一段发问候+价值</p>
            <p>第二段发中间页链接 <code>{{ pageUrl }}</code></p>
            <p>→ 客户点击链接 → 看产品 → 点复制微信 → 加你</p>
          </el-card>
        </div>
      </div>

      <!-- 数字名片应用与功能说明（常驻页面底部） -->
      <div class="dm-guide">
        <div class="dmg-title">🌉 数字名片是什么？怎么用？</div>
        <ul>
          <li><b>是什么：</b>一张会「说话」的电子名片 —— 自动生成账号包装 5 件套（头像/昵称/简介/背景图/置顶视频脚本）+ 专属展示中间页（产品介绍 + 一键复制微信）。</li>
          <li><b>为什么需要：</b>客户从抖音/快手看到你 → 点开资料和链接，1 秒看懂你是做什么的、靠不靠谱，比干巴巴一句「加个微信」转化率高得多。</li>
          <li><b>怎么用（三步）：</b>① 选账号 → 填产品/卖点/微信并保存；② 点「🤖 AI 一键生成」，自动产出 5 件套文案 + 中间页；③ 复制中间页链接，互关后发给客户即可。</li>
          <li><b>进阶玩法：</b>私信暗号【找客户】引导领福利 → 提升客户主动开口率；每条作品简介也可挂名片页，长期沉淀信任。</li>
        </ul>
      </div>
    </el-card>
  </div>
</template>

<script>
import { ref, reactive, onMounted } from 'vue'
import axios from 'axios'
import { ElMessage } from 'element-plus'

export default {
  name: 'LandingPage',
  setup() {
    const step = ref(0)
    const saving = ref(false)
    const generating = ref(false)
    const accounts = ref([])
    const previewTab = ref('package')
    const pageUrl = ref('')
    const content = ref({})

    const form = reactive({
      account_id: null,
      industry: '',
      product_name: '',
      product_desc: '',
      selling_points: '',
      contact_wechat: '',
      contact_phone: '',
      boss_name: '',
      boss_years: '',
      welfare: '',
    })

    const loadAccounts = async () => {
      try {
        const res = await axios.get('/api/v1/accounts/')
        accounts.value = res.data.accounts || res.data || []
      } catch {}
    }

    const loadPage = async () => {
      if (!form.account_id) return
      try {
        const res = await axios.get(`/api/v1/landing-page/${form.account_id}`)
        if (res.data && res.data.exists) {
          form.industry = res.data.industry || ''
          form.product_name = res.data.product_name || ''
          form.product_desc = res.data.product_desc || ''
          form.selling_points = res.data.selling_points || ''
          form.contact_wechat = res.data.contact_wechat || ''
          form.contact_phone = res.data.contact_phone || ''
          form.boss_name = res.data.boss_name || ''
          form.boss_years = res.data.boss_years || ''
          form.welfare = res.data.welfare || ''
          content.value = res.data.generated_content || {}
          pageUrl.value = res.data.page_url || ''
          if (res.data.page_status === 'published') {
            step.value = 1
          }
        }
      } catch {}
    }

    const saveForm = async () => {
      if (!form.account_id) {
        ElMessage.warning('请先选择账号')
        return
      }
      saving.value = true
      try {
        await axios.post('/api/v1/landing-page', { ...form })
        ElMessage.success('资料已保存')
      } catch (e) {
        ElMessage.error('保存失败: ' + (e.response?.data?.detail || e.message))
      } finally {
        saving.value = false
      }
    }

    const generateAll = async () => {
      if (!form.account_id) { ElMessage.warning('请先选择账号'); return }
      if (!form.product_name) { ElMessage.warning('请填写产品名称'); return }
      // 先保存
      await saveForm()
      generating.value = true
      try {
        const res = await axios.post(`/api/v1/landing-page/${form.account_id}/generate`)
        content.value = res.data.generated_content || {}
        pageUrl.value = res.data.page_url || ''
        step.value = 1
        ElMessage.success('AI 已生成账号包装 5 件套 + 中间页！')
      } catch (e) {
        ElMessage.error('AI 生成失败: ' + (e.response?.data?.detail || e.message))
      } finally {
        generating.value = false
      }
    }

    const copyUrl = () => {
      if (pageUrl.value) {
        navigator.clipboard.writeText(pageUrl.value)
        ElMessage.success('链接已复制！可以粘贴到私信里发给客户')
      }
    }

    const openPreview = () => {
      if (form.account_id) {
        window.open(`/api/v1/landing-page/${form.account_id}/preview`, '_blank')
      }
    }

    onMounted(loadAccounts)

    return {
      step, saving, generating, accounts, form, previewTab, pageUrl, content,
      loadAccounts, loadPage, saveForm, generateAll, copyUrl, openPreview,
    }
  }
}
</script>

<style scoped>
.landing-page { max-width: 900px; margin: 0 auto; }
.card-header { display: flex; align-items: center; gap: 12px; }
.card-header .sub { font-size: 13px; color: #888; font-weight: normal; }
.row { display: flex; align-items: center; margin-bottom: 8px; }
.label { font-weight: 500; margin-right: 8px; white-space: nowrap; }
.hint { font-size: 12px; color: #999; margin-top: 4px; }
.package-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
.pkg-item { background: var(--el-fill-color, #fafafa); border: 1px solid var(--el-border-color-light, transparent); border-radius: 8px; padding: 14px; }
.pkg-label { font-size: 13px; color: var(--el-text-color-secondary, #888); margin-bottom: 6px; }
.pkg-value { font-size: 14px; line-height: 1.6; color: var(--el-text-color-regular, #333); }
.script { white-space: pre-wrap; font-size: 13px; background: var(--el-fill-color-light, #fff); padding: 8px; border-radius: 6px; }
.preview-bar { display: flex; align-items: center; gap: 12px; margin-bottom: 16px; flex-wrap: wrap; }
.dm-tip { background: rgba(37,99,235,.1); border: 1px solid rgba(37,99,235,.3); border-radius: 8px; padding: 12px 16px; margin-top: 16px; font-size: 13px; color: var(--el-color-primary, #2563EB); }
.dm-tip code { background: var(--el-fill-color, #fff); padding: 2px 6px; border-radius: 4px; }
.done-section { text-align: center; }
.done-cards { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; margin-top: 24px; text-align: left; }
.done-cards p { font-size: 13px; color: var(--el-text-color-regular, #555); line-height: 1.8; margin: 4px 0; }
.done-cards code { background: var(--el-fill-color, #f0f0f0); padding: 2px 6px; border-radius: 4px; font-size: 12px; }
.lp-wide { width: 100%; max-width: 340px; }
/* 数字名片功能说明 */
.dm-guide {
  margin-top: 28px;
  padding: 16px 18px;
  background: linear-gradient(135deg, rgba(37,99,235,.08), rgba(34,197,94,.06));
  border: 1px solid rgba(37,99,235,.22);
  border-radius: 12px;
  font-size: 13px;
  line-height: 1.9;
  color: var(--el-text-color-regular, #555);
}
.dmg-title { font-size: 15px; font-weight: 700; color: var(--el-color-primary, #2563EB); margin-bottom: 8px; }
.dm-guide ul { margin: 0; padding-left: 18px; }
.dm-guide li { margin: 6px 0; }
.dm-guide b { color: var(--el-text-color-primary, #333); }
/* 手机端：文字左靠 + 输入框撑满 */
@media (max-width: 767px) {
  .landing-page :deep(.el-form-item) { display: block; }
  .landing-page :deep(.el-form-item__label) {
    width: 100% !important; text-align: left; float: none;
    line-height: 1.4; margin-bottom: 4px; font-size: 15px;
  }
  .landing-page :deep(.el-form-item__content) { margin-left: 0 !important; }
  .lp-wide { max-width: none; }
  .package-grid { grid-template-columns: 1fr; }
  .done-cards { grid-template-columns: 1fr; }
  .pkg-item { background: var(--el-fill-color, #fafafa); }
  .pkg-value { color: var(--el-text-color-regular, #333); }
  .script { background: var(--el-fill-color-light, #fff); }
  .dm-tip code { background: var(--el-fill-color, #fff); }
}
</style>